import React from 'react';
import { DialogActions, DialogContent } from '@mui/material';
import { XsBaseDialog } from './XsBaseDialog';
import { XsButton } from './XsButton';

interface Props {
  open: boolean;
  title?: string;
  onClose: () => void;
  onConfirm?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  children?: React.ReactNode;
}

export const XsConfirmationDialog = ({
  open,
  title,
  onClose,
  onConfirm,
  confirmLabel = 'global.ok',
  cancelLabel,
  children
}: Props) => (
  <XsBaseDialog open={open} onClose={onClose} title={title} maxWidth='sm' fullWidth>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      {cancelLabel && (
        <XsButton
          fullWidth={false}
          label={cancelLabel}
          variant='outlined'
          icon={<i className='fal fa-times' />}
          onClick={onClose}
        />
      )}
      <XsButton
        fullWidth={false}
        label={confirmLabel}
        variant='contained'
        icon={<i className='fal fa-check' />}
        onClick={() => (onConfirm ? onConfirm() : onClose())}
      />
    </DialogActions>
  </XsBaseDialog>
);
